import { useSafetyTranslation } from 'cng-common/features/translations'
import { ContactTicketIcon } from 'partner360/common/hpContacts/contactTicketIcon/ContactTicketIcon'

import { ICockpitSalesTeamContact } from '../../helpers/buildSalesTeamItems'
import { getSalesTeamRequestActionKey } from '../../translation'

import styles from './SalesTeamRequestStatus.module.scss'

export const SalesTeamRequestStatus = ({
  item,
  busy,
  actionable = true,
  onClick,
}: {
  item: ICockpitSalesTeamContact
  busy: boolean
  actionable?: boolean
  onClick: () => void
}) => {
  const t = useSafetyTranslation()
  const label =
    item.TicketId > 0
      ? `${t(getSalesTeamRequestActionKey(item.RequestAction))} · ${item.TicketStatus}`
      : null
  return (
    <div className={styles.status}>
      <span className={styles.statusIndicator}>
        <ContactTicketIcon item={item} />
      </span>
      {label &&
        (actionable ? (
          <button type="button" className={styles.requestLink} disabled={busy} onClick={onClick}>
            {label}
          </button>
        ) : (
          <span>{label}</span>
        ))}
    </div>
  )
}
